import { render, staticRenderFns } from "./EcosystemForm.vue?vue&type=template&id=aa0a5f6e"
import script from "./EcosystemForm.vue?vue&type=script&lang=js"
export * from "./EcosystemForm.vue?vue&type=script&lang=js"
import style0 from "./EcosystemForm.vue?vue&type=style&index=0&id=aa0a5f6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports